// import { createSelector } from 'reselect'

export const getProfileGroups = (state) => state.profileGroups.entities.profileGroups;